import { defineComponent as _defineComponent } from 'vue'
import DashboardLots from "@/components/dashboard/DashboardLots.vue";
  import DashboardSale from "@/components/dashboard/DashboardSale.vue";
  import DashboardUpcoming from "@/components/dashboard/DashboardUpcoming.vue";
  import DashboardActivity from "@/components/dashboard/DashboardActivity.vue";
  import { onMounted } from "vue-demi";
  import store from "@/store";
  import { computed, onBeforeUnmount, ref, watch } from "vue";
  import dayjs from "dayjs";
  import { LotActionInterface } from "@/types/LotActionInterface";
  import utc from "dayjs/plugin/utc";

  const bottomSpace = 40;
  
export default /*@__PURE__*/_defineComponent({
  __name: 'DashboardView',
  setup(__props, { expose: __expose }) {
  __expose();

  dayjs.extend(utc);

  const estateId = computed(() => store.state.user.selectedEstateId);
  const name = computed(() => store.state.user?.data?.firstName);
  const hardcodedDashboard = computed(() => {
    if (store.state.user.selectedEstateId === "629d7a743f3dddb9b803adc2") {
      return require("@/assets/images/dashboard-mockup-1.png");
    }

    if (store.state.user.selectedEstateId === "62d5e0ce527605d62c5ca04c") {
      return require("@/assets/images/dashboard-mockup-2.png");
    }

    return "";
  });

  onMounted(() => {
    interval.value = setInterval(() => {
      clock.value = dayjs().format("h:mm A");
    }, 1000);
  });

  function getInfo() {
    getDashboardStatuses();
    getDashboardLotsByMonth();
    getDahboardUpcoming();
    getRecentActivity();
  }

  const statusCounts = ref([]);

  function getDashboardStatuses() {
    store.dispatch("lot/getDashboardStatuses", estateId.value).then((res) => {
      statusCounts.value = res.data;
    });
  }

  const lotsByMonth = ref({});

  function getDashboardLotsByMonth() {
    store
      .dispatch("lot/getDashboardLotsByMonth", estateId.value)
      .then((res) => {
        const lots = res.data;
        let day = dayjs();
        const tmpObject = {
          dates: [] as string[],
          values: [] as string[],
        };

        for (let index = 0; index < 9; index++) {
          const date = `${day.format("MMM")} ‘${day.format("YY")}`;
          const value = lots.filter((item) => {
            return (
              item.year == day.format("YYYY") && item.month - 1 == day.month()
            );
          });

          tmpObject.dates.unshift(date);
          tmpObject.values.unshift(value[0]?.monthlyRevenue || 0);
          day = day.subtract(1, "months");
        }

        lotsByMonth.value = tmpObject;
      });
  }

  const upcoming = ref([]);

  function getDahboardUpcoming() {
    store.dispatch("lot/getDahboardUpcoming", estateId.value).then((res) => {
      upcoming.value = res.data;
    });
  }

  const recentActivity = ref<LotActionInterface[]>([]);

  function getRecentActivity() {
    store
      .dispatch("lot/getLotActionsByEstate", store.state.user.selectedEstateId)
      .then((res) => {
        recentActivity.value = res.data;
      });
  }

  watch(
    () => estateId.value,
    () => {
      if (estateId.value) {
        getInfo();
      }
    },
    { immediate: true }
  );

  const clock = ref(dayjs().format("h:mm A"));
  const interval = ref();

  onBeforeUnmount(() => {
    clearInterval(interval.value);
  });

  const helloWords = computed(() => {
    const time = new Date().getHours();

    if (time >= 5 && time < 12) {
      return "Good morning";
    } else if (time >= 12 && time < 17) {
      return "Good afternoon";
    } else {
      return "Good evening";
    }
  });

const __returned__ = { bottomSpace, estateId, name, hardcodedDashboard, getInfo, statusCounts, getDashboardStatuses, lotsByMonth, getDashboardLotsByMonth, upcoming, getDahboardUpcoming, recentActivity, getRecentActivity, clock, interval, helloWords, DashboardLots, DashboardSale, DashboardUpcoming, DashboardActivity, get onMounted() { return onMounted }, get store() { return store }, computed, onBeforeUnmount, ref, watch, get dayjs() { return dayjs }, get LotActionInterface() { return LotActionInterface }, get utc() { return utc } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})